const initialState = {
  index: [],
  selected: [],
  data: {},
};

const Company = (state = initialState, action) => {
  switch (action.type) {
    case "COMPANY_INDEX":
      return { ...state, index: action.payload.index };
    case "COMPANY_SELECTED":
      return { ...state, selected: action.payload.selected };
    case "COMPANY_DATA":
      return { ...state, data: action.payload.data };
    case "COMPANY_RESET":
      return initialState;
    default:
      return state;
  }
};

export default Company;
